module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-icon-D.ebc5f587.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-icon-D.png
// module id = 2517
// module chunks = 11